/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAllGolabAppsAndLabsResponse } from '../../models/create-all-golab-apps-and-labs-response';

export interface GolabControllerCreateGolabAppsAndLabs$Params {
}

export function golabControllerCreateGolabAppsAndLabs(http: HttpClient, rootUrl: string, params?: GolabControllerCreateGolabAppsAndLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateAllGolabAppsAndLabsResponse>> {
  const rb = new RequestBuilder(rootUrl, golabControllerCreateGolabAppsAndLabs.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateAllGolabAppsAndLabsResponse>;
    })
  );
}

golabControllerCreateGolabAppsAndLabs.PATH = '/golab/create-golab-apps-and-labs';
